import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { equals } from "ramda";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleRight } from "@fortawesome/pro-regular-svg-icons";
import clsx from "clsx";

import SidebarTreeItemLabel from "./SidebarTreeItemLabel";
import TreeItem from "@material-ui/lab/TreeItem";

const useStyles = makeStyles(theme => ({
  approved: {
    color: theme.palette.approved,
  },

  content: {},

  header: {
    fontSize: "1.6rem",
    fontWeight: "inherit",
  },

  pending: {
    color: theme.palette.primary.brandPrimary,
  },

  rejected: {
    color: theme.palette.rejected,
  },

  rootApproved: {
    "&$selected": {
      "&> $content, &> $content:hover": {
        backgroundColor: theme.palette.primary.green.light,
      },
    },
  },

  rootRejected: {
    "&$selected": {
      "&> $content, &> $content:hover": {
        backgroundColor: theme.palette.primary.red.light,
      },
    },
  },

  selected: {
    fontWeight: theme.typography.fontWeightBold,
  },
}));

const SidebarTreeItem = props => {
  const classes = useStyles();
  const {
    count,
    nestedTree,
    icon,
    isModule,
    onClick,
    label,
    nodeId,
    nodeType,
    tooltipLabel,
    variant,
    ...otherProps
  } = props;

  const getTypographyProps = type => {
    switch (type) {
      case "root":
        return { classes: { root: classes.header } };
      default:
        // return { classes: { root: classes.treeItem } };
        return undefined;
    }
  };

  return (
    <TreeItem
      nodeId={nodeId}
      onClick={onClick}
      classes={{
        root: clsx({
          [classes.rootApproved]: equals(variant, "approved"),
          [classes.rootRejected]: equals(variant, "rejected"),
        }),
        content: classes.content,
        label: clsx(classes.label, {
          [classes.approved]: equals(variant, "approved"),
          [classes.pending]: equals(variant, "pending"),
          [classes.rejected]: equals(variant, "rejected"),
        }),
        selected: classes.selected,
      }}
      expandIcon={<FontAwesomeIcon icon={faAngleRight} />}
      collapseIcon={<FontAwesomeIcon icon={faAngleDown} />}
      label={
        <SidebarTreeItemLabel
          tooltipLabel={tooltipLabel}
          labelText={label}
          icon={icon}
          TypographyProps={getTypographyProps(nodeType)}
        />
      }
      {...otherProps}
    >
      {nestedTree}
    </TreeItem>
  );
};

export default SidebarTreeItem;
